import { render, staticRenderFns } from "./search-duration-type.vue?vue&type=template&id=6f2ea77b&scoped=true&"
import script from "./search-duration-type.vue?vue&type=script&lang=js&"
export * from "./search-duration-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2ea77b",
  null
  
)

export default component.exports